export const eraserIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_26885_58302)">
    <path d="M0.758557 17.8283L6.35415 23.6958C6.47482 23.8228 6.61825 23.9235 6.77618 23.9921C6.93411 24.0608 7.10343 24.096 7.27439 24.0957H22.8949V21.366H13.8384L23.2386 11.509C24.2538 10.4458 24.2538 8.71246 23.2386 7.64924L16.7943 0.893232C16.3056 0.382492 15.6438 0.0957031 14.9538 0.0957031C14.2639 0.0957031 13.6021 0.382492 13.1134 0.893232L6.93076 7.37491L0.742937 13.9849C0.263937 14.4995 -0.00289844 15.1909 2.37506e-05 15.9099C0.00294595 16.629 0.275391 17.318 0.758557 17.8283ZM14.9538 2.82313L21.3968 9.57914L18.0308 13.1086L11.5879 6.35264L14.9538 2.82313ZM8.78034 9.29526L9.74743 8.28254L16.1904 15.0385L10.259 21.2582C10.2273 21.2925 10.1973 21.3285 10.1692 21.366H7.81325L2.60033 15.897L8.78034 9.29526Z"
      fill="var(--zbp-svg-primary-color, black)"
    />
  </g>
  <defs>
    <clipPath id="clip0_26885_58302">
      <rect width="24" height="24" fill="var(--zbp-svg-secondary-color, white)" transform="translate(0 0.0957031)"/>
    </clipPath>
  </defs>
</svg>
`;
